// amount of attempts to connect to google maps object
let connectionAttempts = 0
// assume google api exists and is loaded
declare var google: any
function showGoogleMap(pluginSelector: HTMLElement) {
    const markerIconPath: string =
        pluginSelector.dataset.txHbcontactMarkericonpath

    const position = {
        lat: parseFloat(pluginSelector.dataset.txHbcontactLat),
        lng: parseFloat(pluginSelector.dataset.txHbcontactLng),
    }

    const style = [
        {
            featureType: "administrative",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#000000",
                },
            ],
        },
        {
            featureType: "administrative.neighborhood",
            elementType: "geometry.stroke",
            stylers: [
                {
                    visibility: "on",
                },
            ],
        },
        {
            featureType: "landscape",
            elementType: "all",
            stylers: [
                {
                    color: "#f2f3f4",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "all",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "all",
            stylers: [
                {
                    saturation: -100,
                },
                {
                    lightness: 45,
                },
            ],
        },
        {
            featureType: "road.highway",
            elementType: "all",
            stylers: [
                {
                    visibility: "simplified",
                },
            ],
        },
        {
            featureType: "road.arterial",
            elementType: "labels.icon",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "transit",
            elementType: "all",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "all",
            stylers: [
                {
                    color: "#2489c8",
                },
                {
                    visibility: "on",
                },
            ],
        },
    ]

    // initialize map
    const map = new google.maps.Map(pluginSelector, {
        styles: style,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        center: {
            lat: position.lat,
            lng: position.lng,
        },
        zoom: 8,
    })

    // custom marker icon
    const markerIcon = {
        url: markerIconPath,
        scaledSize: new google.maps.Size(48, 48),
        labelOrigin: new google.maps.Point(0, 0),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        optimized: false,
    }

    // marker
    const marker = new google.maps.Marker({
        map: map,
        icon: markerIcon,
        position: new google.maps.LatLng(position.lat, position.lng),
    })
}

function txHbContact() {
    const pluginSelectors: NodeListOf<HTMLElement> = document.querySelectorAll(
        "[data-tx-hbcontact-map]",
    )

    if (pluginSelectors.length === 0) {
        return false
    }

    if (typeof google !== "object" || typeof google.maps !== "object") {
        if (connectionAttempts > 30) {
            return false
        }

        setTimeout(() => {
            connectionAttempts++
            txHbContact()
        }, 500)

        return false
    }

    pluginSelectors.forEach((pluginSelector: HTMLElement) => {
        showGoogleMap(pluginSelector)
    })
}


//@ts-ignore
window.addEventListener("ucEvent", (e: CustomEvent<CustomEventDetail>) => {
    if (e.detail?.event === "consent_status" && e.detail["Google Maps"]) {
        if (!document.getElementById("googleMapsScript")) {
            const googleMapsSrc: string = (
                document.getElementById(
                    "contact-map-script",
                ) as HTMLInputElement
            ).value

            if (googleMapsSrc) {
                const googleMapsScript = document.createElement("script")
                googleMapsScript.src = googleMapsSrc
                googleMapsScript.id = "googleMapsScript"
                googleMapsScript.onload = () => {
                    txHbContact()
                }

                document.body.appendChild(googleMapsScript)
            }
        } else {
            txHbContact()
        }
    }
})

// Define a type for the CustomEvent detail property
interface CustomEventDetail {
    event: string
    [key: string]: any
}
